import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EQuestionTextTypes {
  Set = 'NEW_QUESTION/TEXT/SET',
}

export type TSetQuestionText = ITypedReduxAction<EQuestionTextTypes.Set, string>;

/**
 * Redux action, который записывает в store вопрос
 * @param text string
 */
export const setQuestionText: (text: string) => TSetQuestionText = actionGenerator<EQuestionTextTypes.Set, string>(
  EQuestionTextTypes.Set,
);
